export default {
    home_page_title: "Profil",
    security_page_title: "Centrum bezpieczeństwa",
    security_setting_page_title: "Centrum bezpieczeństwa",
    security_phone_label: "Numer telefonu",
    security_email_label: "E-mail",
    security_question_label: "Pytanie uwierzytelniające",
    security_unset_text: "Nie ustawiono",
    security_setted_text: "Ustawiono",
    security_question_options: [
        "Jak nazywa się Twoja matka ?",
        "Data urodzenia Twojego partnera ?",
        "Jak nazywa się Twój ojciec ?",
        "Twój numer legitymacji szkolnej/studenckiej lub numer pracownika to ?",
        "Jak nazywa się osoba najbliższa Tobie w dzieciństwie ?",
        "Jak nazywa się osoba, która najbardziej na Ciebie wpłynęła ?"
    ],
    password_lost_page_title: "Zapomniałem hasła.",
    password_reset_page_title: "Resetuj hasło",
    password_lost_account_placeholder:
        "Wpisz nazwę konta, do którego zapomniałeś hasła.",
    empty_lost_account_tips: "Proszę wpisać nazwę użytkownika",
    iscorrect_lost_account_tips: "Użytkownik nie istnieje",
    password_reset_new_placeholder: "Nowe hasło",
    password_reset_confirm_placeholder: "Potwierdź nowe hasło",
    password_verify_page_title: "Weryfikacja tożsamości",
    phone_verify_page_title: "Weryfikacja tożsamości",
    email_verify_page_title: "Weryfikacja tożsamości",
    question_verify_page_title: "Weryfikacja tożsamości",
    phone_reset_page_title: "Numer telefonu",
    email_reset_page_title: "E-mail",
    question_reset_page_title: "Pytanie uwierzytelniające",
    phone_binding_text: "Twój powiązany nr tel. kom. to",
    email_binding_text: "Twój powiązany adres e-mail to",
    verification_code_text: "Kod weryfikacyjny",
    resend_text: "Ponowne wysyłanie",
    empty_phone_number_tips: "Proszę wprowadzić numer telefonu komórkowego",
    iscorrect_phone_number_tips: "Wpisz poprawny numer telefonu komórkowego",
    empty_verification_code_tips: "Proszę wprowadzić kod weryfikacyjny",
    iscorrect_verification_code_tips: "Błędny kod weryfikacyjny",
    password_placeholder: "Hasło",
    empty_password_tips: "Wprowadź hasło.",
    iscorrect_password_tips: "Błędne hasło",
    mismatched_rule_password_tips:
        "Hasło nie może zawierać znaków: &, #, spacja.",
    different_confirm_password_tips: "Hasła różnią się od siebie.",
    empty_email_tips: "Wprowadź adres e-mail",
    iscorrect_email_tips: "Niepoprawny adres e-mail.",
    answer_placeholder: "Odpowiedź",
    empty_question_tips: "Wybierz pytanie zabezpieczające",
    empty_answer_tips: "Wpisz odpowiedź,",
    iscorrect_answer_tips: "Błędna odpowiedź",
    next_step_text: "Dalej",
    submit_text: "Wyślij",
    submit_success_tips: "Wprowadzenie zmiany",
    submit_error_tips: "Operacja nie powiodła się, spróbuj ponownie",
    get_data_fail_tips:
        "Wykryto zakłócenia w połączeniu internetowym. Spróbuj później.",
    use_other_verification_type_text: "Weryfikacja za pomocą innych metod",
    custom_support_notice:
        "Do tego konta nie ustawiono metody przywracania hasła. Aby zgłosić problem otwórz poniższy link przy pomocy komputera." +
        process.env.VUE_APP_ORIGIN_PROFILE
};
